const ROOT_CONSTANTS = {
  // event name triggered from store, listened to by views
  CHANGE_EVENT: 'change',

  //General Constants
  LISTING_ITEMS_PER_PAGE: 20,
  DEFAULT_INTEGER_VALUE: -1,
  DATA_SCHEMA_DEFAULT_PARENT_ID: -1,
  DATA_SCHEMA_CHILD_KEY_NAME: 'properties',
  SCHEMA_EDITOR_FORM_HEIGHT: 810,
  DATA_NOT_AVAILABLE: '-',
  RECAPTCHA_KEY: '6LdOKR4TAAAAAGbNF6jZTBCL_l-YZe1Lk9Rbpxrf',
  HC_SOURCE_FIELD_NAMES: ['hc_scale_factor', 'docker.instances'],
  HC_SINK_FIELD_NAMES: ['hc_scale_factor'],

  SourceStatus: {
    INIT: 'INIT',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    RATE_LIMITED: 'RATE_LIMITED',
  },

  IngestionStatus: {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    PARTIAL: 'PARTIAL',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR',
    QUEUED_REINGEST: 'QUEUED_REINGEST',
    RECOVERED: 'RECOVERED',
    DOWNLOADING: 'DOWNLOADING',
    PROCESSING: 'PROCESSING',
    POST_PROCESSING: 'POST_PROCESSING',
    STARTED: 'STARTED',
    PARSING: 'PARSING',
  },

  MetricsType: {
    Last7Days: 'last_7_d',
  },

  AlertTypes: {
    Info: 'info',
    Success: 'success',
    Warning: 'warning',
    Danger: 'danger',
  },

  IterationTypes: [
    {
      label: 'ID (String) In Response',
      value: 'response.id.string',
    },
    {
      label: 'ID (number) in Response',
      value: 'response.id.number',
    },
    {
      label: 'Next Token In Response',
      value: 'paging.next.token',
    },
    {
      label: 'Next URL in Response',
      value: 'paging.next.url',
    },

    {
      label: 'Next URL in Response Header',
      value: 'link.header',
    },
    {
      label: 'Offset',
      value: 'paging.incrementing.offset',
    },
    {
      label: 'Page Number',
      value: 'paging.incrementing',
    },
    {
      label: 'GraphQL Page',
      value: 'graphql.page',
    },
    {
      label: 'GraphQL Cursor',
      value: 'graphql.cursor',
    },
    {
      label: 'Asynchronous Job Status API',
      value: 'async.poll',
    },
    {
      label: 'Process API Response as File',
      value: 'body.as.file',
    },
  ],

  IterationPrefixes: {
    DATA_MAP: 'lookup',
    STAGE: 'step',
  },

  CodeLanguages: {
    JOLT: 'jolt_custom',
    PYTHON: 'python',
    PYTHON3: 'python3',
    JAVASCRIPT: 'javascript',
    FLINK_SQL: 'flink_sql',
    SPARK_SQL: 'spark_sql',
  },

  DefaultCode: {
    jolt_custom: '[]',
    python: `def transform(input, metadata, args):
    # Sample python transform to pass all attributes through
    return input`,
    python3: `async def transform(input, metadata, args):
    # Sample python 3 transform to pass all attributes through
    return input`,
    javascript: `function transform(input, metadata, args) {
  // Sample javascript transform to pass all attributes through
  return input;
}`,
  },

  EditorModeByLanguage: {
    jolt_custom: { name: 'json', json: true },
    python: {
      name: 'python',
      singleLineStringErrors: false,
    },
    python3: {
      name: 'python3',
      singleLineStringErrors: false,
    },
    javascript: { name: 'javascript' },
    flink_sql: { name: 'sql' },
    spark_sql: { name: 'sql' },
  },

  ListingLayouts: {
    TILE: 'TILE',
    LIST: 'LIST',
  },

  SortCriteriaInfo: {
    NAME_ASC: {
      label: 'Name (A -> Z)',
      value: 'NAME_ASC',
      sortKey: 'name',
      sortOrder: 'asc',
    },
    NAME_DESC: {
      label: 'Name (Z -> A)',
      value: 'NAME_DESC',
      sortKey: 'name',
      sortOrder: 'desc',
    },
    LAST_CREATED_DESC: {
      label: 'Most Recent First',
      value: 'LAST_CREATED_DESC',
      sortKey: 'created_at',
      sortOrder: 'desc',
    },
    LAST_CREATED_ASC: {
      label: 'Oldest First',
      value: 'LAST_CREATED_ASC',
      sortKey: 'created_at',
      sortOrder: 'asc',
    },
  },

  SortCriteria: {
    LAST_CREATED_DESC: 'LAST_CREATED_DESC',
    LAST_CREATED_ASC: 'LAST_CREATED_ASC',
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
  },

  // Never change the order in this array, it is used in multiple components to validate grouping algo
  GROUPING_ALGO: [
    {
      label: 'Array of Records',
      value: 'ALGO_ARRAY',
    },
    {
      label: 'Property Inside JSON Object',
      value: 'ALGO_JSON',
    },
    {
      label: 'Code',
      value: 'ALGO_CODE',
    },
  ],
};

export const CodeLanguages = ROOT_CONSTANTS.CodeLanguages;
export const EditorModeByLanguage = ROOT_CONSTANTS.EditorModeByLanguage;
export const DATASETS_UNSYNCABLE = ['in_memory', 'cdc', 'elt'];
export const CONNECTORS_WITHOUT_PATH = ['s3_iceberg', 'pinecone'];

export default ROOT_CONSTANTS;
